export enum RoomClosedReason {
    PressSkip = 'pressSkip',
    PressSkipBeforePlayerStarted = 'pressSkipBeforePlayerStarted',
    PressSkipPlayerNotPlaying = 'pressSkipPlayerNotPlaying',
    PressSkipPartnerReconnectingBeforePlayerStarted = 'pressSkipPartnerReconnectingBeforePlayerStarted',
    PressSkipPartnerReconnecting = 'pressSkipPartnerReconnecting',
    PressSkipPartnerLeft = 'pressSkipPartnerLeft',
    PressStop = 'pressStop',
    PressStopBeforePlayerStarted = 'pressStopBeforePlayerStarted',
    PressStopPartnerReconnectingBeforePlayerStarted = 'pressStopPartnerReconnectingBeforePlayerStarted',
    PressStopPartnerReconnecting = 'pressStopPartnerReconnecting',
    PressStopPlayerNotPlaying = 'pressStopPlayerNotPlaying',
    PressStopPartnerLeft = 'pressStopPartnerLeft',
    PartnerLeftTimeout = 'partnerLeftTimeout',
    ModeratorStop = 'moderatorStop',
    AutoModerationStop = 'autoModerationStop',
    InvalidBalance = 'invalidBalance',
    UserBlocked = 'userBlocked',
    GoneAway = 'goneAway',
    GoneAwayBeforePlayerStarted = 'goneAwayBeforePlayerStarted',
    GoneAwayPartnerReconnectingBeforePlayerStarted = 'goneAwayPartnerReconnectingBeforePlayerStarted',
    GoneAwayPartnerReconnecting = 'goneAwayPartnerReconnecting',
    GoneAwayPlayerNotPlaying = 'goneAwayPlayerNotPlaying',
    GoneAwayPartnerLeft = 'goneAwayPartnerLeft',
    SessionExists = 'sessionExists',
    FreeTimePackage = 'freeTimePackage',
    UnstableConnection = 'unstableConnection',
    /** @deprecated */
    StreamNotStarted = 'streamNotStarted',
    OperatorBroadcasterNotStarted = 'operatorBroadcasterNotStarted',
    UserPlayerNotStarted = 'userPlayerNotStarted',
    UserPlayerNotStartedTimeout = 'userPlayerNotStartedTimeout',
    Timeout = 'timeout',
    OfflineRoom = 'offlineRoom',
    CameraTurnedOff = 'cameraTurnedOff',
    PlayerError = 'playerError',
    NoAnswer = 'noAnswer',
    CrossCallInterrupt = 'crossCallInterrupt',
    PermissionsRevoked = 'permissionsRevoked'
}

export enum RoomStatus {
    Active = 'active',
    Closed = 'closed',
    Suspended = 'suspended',
    Pending = 'pending'
}


